// import React, { useState } from "react";
// import {
//   Card,
//   Button,
//   Collapse,
//   Checkbox,
//   Tag,
//   Select,
//   Space
// } from "antd";
// import { Building, Lock, Plus, X } from "lucide-react";
// import "./BrandsOverridesTab.css";

// const { Panel } = Collapse;
// const { Option } = Select;

// // Mock brands data
// const availableBrands = [
//   { id: "nike", name: "Nike Store", location: "New York" },
//   { id: "adidas", name: "Adidas Outlet", location: "Los Angeles" },
//   { id: "puma", name: "Puma Flagship", location: "Chicago" },
//   { id: "vans", name: "Vans Store", location: "San Francisco" }
// ];

// // Example branch data (per brand)
// const brandBranches = {
//   nike: [
//     { id: "ny-downtown", name: "NY Downtown" },
//     { id: "ny-uptown", name: "NY Uptown" },
//     { id: "brooklyn", name: "Brooklyn" }
//   ],
//   adidas: [
//     { id: "la-central", name: "LA Central" },
//     { id: "la-west", name: "LA West" }
//   ],
//   puma: [
//     { id: "chicago-central", name: "Chicago Central" },
//     { id: "chicago-south", name: "Chicago South" }
//   ],
//   vans: [
//     { id: "sf-downtown", name: "SF Downtown" },
//     { id: "sf-ocean", name: "SF Ocean Beach" }
//   ]
// };

// // Menu items
// const menuItems = [
//   { id: "brand", name: "Brand" },
//   { id: "branch", name: "Branch" },
//   { id: "campaign", name: "Campaign" },
//   { id: "screen", name: "Screen" },
//   { id: "playlist", name: "Playlist" },
//   { id: "media", name: "Media" },
//   { id: "media-trash", name: "Media Trash" },
//   { id: "widget", name: "Widget" },
//   { id: "event", name: "Event" },
//   { id: "dashboard", name: "Dashboard" },
//   { id: "analytics", name: "Analytics" },
//   { id: "activity-log", name: "Activity Log" },
//   { id: "media-log", name: "Media Log" },
//   { id: "user", name: "User" },
//   { id: "role", name: "Role" },
//   { id: "permission", name: "Permission" }
// ];


// // CRUD operations
// const crudOperations = [
//   { id: "create", name: "Create" },
//   { id: "read", name: "Read" },
//   { id: "update", name: "Update" },
//   { id: "delete", name: "Delete" },
//   { id: "publish", name: "Publish" },
//   { id: "upload", name: "Upload" }
// ];

// // Generate all permissions
// const generatePermissions = () => {
//   const permissions = [];
//   menuItems.forEach((menu) => {
//     crudOperations.forEach((op) => {
//       permissions.push(`${menu.id}_${op.id}`);
//     });
//   });
//   return permissions;
// };
// const availablePermissions = generatePermissions();

// // Subscription limits
// const subscriptionLimits = {
//   basic: availablePermissions.filter(
//     (p) => p.includes("_read") || p.includes("_create")
//   ),
//   pro: availablePermissions.filter(
//     (p) => !p.includes("_publish") && !p.includes("_upload")
//   ),
//   business: availablePermissions
// };


// const BrandsOverridesTab = ({ userData, setUserData , accessContents=[]}) => {
//   const [activeBrands, setActiveBrands] = useState([]);
//   const [brandToAdd, setBrandToAdd] = useState(null);

//   const allowedPermissions = (userData && userData.subscriptionPlan) ? subscriptionLimits[userData.subscriptionPlan] : [];

//   // Add new brand access (select all branches by default)
//   const addBrandAccess = () => {
//     if (!brandToAdd) return;
//     const defaultBranches = brandBranches[brandToAdd]?.map(b => b.id) || [];
//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandToAdd]: { branches: defaultBranches, override: null }
//       }
//     });
//     setBrandToAdd(null);
//   };

//   // Remove brand access
//   const removeBrandAccess = (brandId) => {
//     const updated = { ...userData.brands };
//     delete updated[brandId];
//     setUserData({ ...userData, brands: updated });
//   };

//   // Toggle branch
//   const toggleBranch = (brandId, branchId) => {
//     const current = userData.brands?.[brandId]?.branches || [];
//     const updated = current.includes(branchId)
//       ? current.filter((b) => b !== branchId)
//       : [...current, branchId];

//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           branches: updated
//         }
//       }
//     });
//   };

//   // Select All branches
//   const selectAllBranches = (brandId) => {
//     const allBranches = brandBranches[brandId]?.map(b => b.id) || [];
//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           branches: allBranches
//         }
//       }
//     });
//   };

//   // Deselect All branches
//   const deselectAllBranches = (brandId) => {
//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           branches: []
//         }
//       }
//     });
//   };

//   // Add/Remove override
//   const addOverride = (brandId) => {
//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           override: { enabled: [], disabled: [] }
//         }
//       }
//     });
//   };

//   const removeOverride = (brandId) => {
//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           override: null
//         }
//       }
//     });
//   };

//   // Toggle permission (3-state: inherit → enabled → disabled → inherit)
//   const togglePermission = (brandId, permission) => {
//     const override = userData.brands?.[brandId]?.override;
//     if (!override) return;

//     const { enabled, disabled } = override;

//     let updatedEnabled = [...enabled];
//     let updatedDisabled = [...disabled];

//     if (enabled.includes(permission)) {
//       // Explicitly enabled → move to disabled
//       updatedEnabled = enabled.filter((p) => p !== permission);
//       updatedDisabled.push(permission);
//     } else if (disabled.includes(permission)) {
//       // Explicitly disabled → back to inherit
//       updatedDisabled = disabled.filter((p) => p !== permission);
//     } else {
//       // Inherited → explicitly enable
//       updatedEnabled.push(permission);
//     }

//     setUserData({
//       ...userData,
//       brands: {
//         ...userData.brands,
//         [brandId]: {
//           ...(userData.brands?.[brandId] || {}),
//           override: {
//             enabled: updatedEnabled,
//             disabled: updatedDisabled
//           }
//         }
//       }
//     });
//   };

//   const brandsWithAccess = Object.entries(userData && userData.brands ? userData.brands : {});

//   return (
//     <Card
//       title={
//         <span className="card-title">
//           <Building size={16} /> Brand Access & Permission Overrides
//         </span>
//       }
//     >
//       <p className="subtitle">
//         Add or remove brand access for this user. By default, each brand
//         inherits main role permissions. You can also limit branch access and
//         apply overrides to permissions (brand-wide).
//       </p>

//       {/* Add brand selector */}
//       <Space style={{ marginBottom: 16 }}>
//         <Select
//           style={{ width: 220 }}
//           placeholder="Select brand"
//           value={brandToAdd}
//           onChange={setBrandToAdd}
//         >
//           {availableBrands
//             .filter((b) => !Object.keys(userData && userData.brands ? userData.brands : {}).includes(b.id))
//             .map((b) => (
//               <Option key={b.id} value={b.id}>
//                 {b.name} - {b.location}
//               </Option>
//             ))}
//         </Select>
//         <Button
//           type="primary"
//           className="button-icon-text"
//           icon={<Plus size={14} />}
//           onClick={addBrandAccess}
//           disabled={!brandToAdd}
//         >
//           Add Brand
//         </Button>
//       </Space>

//       <Collapse
//         activeKey={activeBrands}
//         onChange={setActiveBrands}
//         expandIconPosition="end"
//       >
//         {brandsWithAccess.map(([brandId, brandData]) => {
//           const brand = availableBrands.find((b) => b.id === brandId);
//           const branches = brandBranches[brandId] || [];
//           const hasOverride = brandData.override;

//           return (
//             <Panel
//               key={brandId}
//               header={
//                 <div className="panel-header">
//                   <div className="panel-header-left">
//                     <Building size={16} className="brand-icon" />
//                     <div>
//                       <div className="brand-name">{brand.name}</div>
//                       <div className="brand-location">{brand.location}</div>
//                     </div>
//                     {hasOverride && <Tag color="blue">Override Active</Tag>}
//                   </div>
//                   <Button
//                     type="text"
//                     size="small"
//                     danger
//                     className="button-icon-text"
//                     icon={<X size={14} />}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       removeBrandAccess(brandId);
//                     }}
//                   >
//                     Remove Brand
//                   </Button>
//                 </div>
//               }
//             >
//               {/* Branch Access Section */}
//               <div className="branch-access">
//                 <h4>Branch Access</h4>
//                 <div>
//                   <Space style={{ marginBottom: 8 }}>
//                     <Button size="small" disabled={branches.length == userData.brands[brandId].branches.length} onClick={() => selectAllBranches(brandId)}>
//                       Select All
//                     </Button>
//                     <Button size="small" disabled={branches.length == 0} onClick={() => deselectAllBranches(brandId)}>
//                       Deselect All
//                     </Button>
//                   </Space>
//                 </div>
//                 {branches.map((branch) => (
//                   <Checkbox
//                     key={branch.id}
//                     checked={brandData.branches?.includes(branch.id)}
//                     onChange={() => toggleBranch(brandId, branch.id)}
//                   >
//                     {branch.name}
//                   </Checkbox>
//                 ))}
//               </div>

//               {/* Override Section */}
//               {!hasOverride ? (
//                 <div className="no-override">
//                   <p className="inherit-text">
//                     This brand inherits permissions from the main role (
//                     {userData.mainRole}).
//                   </p>
//                   <Button
//                     className="button-icon-text"
//                     onClick={() => addOverride(brandId)}
//                     icon={<Plus size={14} />}
//                   >
//                     Add Permission Override
//                   </Button>
//                 </div>
//               ) : (
//                 <div>
//                   {/* Permissions Table */}
//                   <div className="permissions-table-container">
//                     <table className="permissions-table">
//                       <thead>
//                         <tr>
//                           <th className="menu-col">Menu</th>
//                           {crudOperations.map((op) => (
//                             <th key={op.id} className="crud-col">
//                               <div className="crud-header"> {/* <span>{op.icon}</span> */}
//                                 <span className="crud-name">{op.name}</span>
//                               </div>
//                             </th>))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {menuItems.map((menu) => (
//                           <tr key={menu.id}>
//                             <td className="menu-cell"> {/* <span>{menu.icon}</span> */} {menu.name}
//                             </td> {crudOperations.map((op) => { const permission = `${menu.id}_${op.id}`; const isExplicitEnabled = brandData.override?.enabled.includes(permission); const isExplicitDisabled = brandData.override?.disabled.includes(permission); const isChecked = isExplicitEnabled || (!isExplicitDisabled && allowedPermissions.includes(permission)); return (<td key={op.id} className="crud-cell"> {allowedPermissions.includes(permission) ? (<Checkbox checked={isChecked} indeterminate={!isExplicitEnabled && !isExplicitDisabled} onChange={() => togglePermission(brandId, permission)} />) : (<Lock size={14} className="lock-icon" />)} </td>); })} </tr>))} </tbody> </table> </div>
//                 </div>
//               )}

//             </Panel>
//           );
//         })}
//       </Collapse>
//     </Card>
//   );
// };

// export default BrandsOverridesTab;
//-------------------------------------------
// import React, 


import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import {
  Card,
  Button,
  Collapse,
  Checkbox,
  Tag,
  Select,
  Space,
  message,
  Alert,
  Modal
} from "antd";
import { Building, Lock, Plus, X } from "lucide-react";
import "./BrandsOverridesTab.css";

const { Panel } = Collapse;
const { Option } = Select;

// Menu items
const menuItems = [
  { id: "brand", name: "Workspace" },
  { id: "branch", name: "Location" },
  { id: "campaign", name: "Campaign" },
  { id: "screen", name: "Screen" },
  { id: "playlist", name: "Playlist" },
  { id: "media", name: "Media" },
  { id: "media_trash", name: "Media Trash" },
  { id: "widget", name: "Widget" },
  { id: "event", name: "Event" },
  { id: "dashboard", name: "Dashboard" },
  { id: "analytics", name: "Analytics" },
  { id: "activitylog", name: "Activity Log" },
  { id: "medialog", name: "Media Log" },
  { id: "user", name: "User" },
  { id: "role", name: "Role" },
  { id: "permission", name: "Permission" }
];

// CRUD operations
const crudOperations = [
  { id: "canCreate", name: "Create" },
  { id: "canRead", name: "Read" },
  { id: "canUpdate", name: "Update" },
  { id: "canDelete", name: "Delete" },
  { id: "canPublish", name: "Publish" },
  { id: "canUpload", name: "Upload" }
];

const BrandsOverridesTab = forwardRef(({ userData = {}, accessContents = [], onDataChange = () => { }, onStepComplete = () => { } }, ref) => {
  const [activeBrands, setActiveBrands] = useState([]);
  const [brandToAdd, setBrandToAdd] = useState([]);
  const [currentSelectedBrandData, setCurrentSelectedBrandData] = useState([]);

  useImperativeHandle(ref, () => ({
    validate: () => {
      return new Promise((resolve) => {
        if (brandToAdd && brandToAdd.length > 0) {
          Modal.confirm({
            title: "Unsaved Selections",
            content: "You have selected brands but haven't added them yet. Do you want to discard these selections and proceed?",
            okText: "Yes, Discard & Proceed",
            cancelText: "No, Stay",
            onOk: () => {
              setBrandToAdd([]);
              resolve(true);
            },
            onCancel: () => {
              resolve(false);
            }
          });
        } else {
          resolve(true);
        }
      });
    }
  }));

  useEffect(() => {
    console.log("**** currentSelectedBrandData", JSON.stringify(currentSelectedBrandData));

    onDataChange(currentSelectedBrandData);
  }, [currentSelectedBrandData]);

  useEffect(() => {
    if (userData?.accesscontent) {
      try {
        const parsed = JSON.parse(userData.accesscontent);

        // ✅ If [] → means All Brands
        if (Array.isArray(parsed) && parsed.length === 0) {
          setCurrentSelectedBrandData([]);
          return;
        }

        setCurrentSelectedBrandData(parsed);
      } catch (e) {
        console.error("Invalid accesscontent JSON");
      }
    }

  }, [userData]);

  useEffect(() => {
    if (brandToAdd.includes("__all_brands__") && brandToAdd.length > 1) {
      setBrandToAdd(["__all_brands__"]);
    }
  }, [brandToAdd]);




  // Add new brand
  const addBrandAccess = () => {
    if (!brandToAdd || brandToAdd.length === 0) return;

    // ✅ If user selected All Brands
    if (brandToAdd.includes("__all_brands__")) {
      setCurrentSelectedBrandData([]);  // empty array = all brands
      setBrandToAdd([]);
      return;
    }

    const newItems = [];

    brandToAdd.forEach((brandId) => {
      const brand = accessContents.find(
        (b) => String(b.BrandID) === String(brandId)
      );
      if (!brand) return;

      const defaultBranches = brand.Branches.map((b) =>
        String(b.BranchID)
      );

      newItems.push({
        brandid: String(brandId),
        branches: defaultBranches,
        override_permissions: {}
      });
    });

    setCurrentSelectedBrandData([
      ...currentSelectedBrandData,
      ...newItems,
    ]);

    // reset selection
    setBrandToAdd([]);
  };

  const ALL = "__all_brands__";

  const handleSelect = (value) => {
    // User selects ALL BRANDS
    if (value === ALL) {
      setBrandToAdd([ALL]);  // Clear everything else
      return;
    }

    // User selects a normal brand
    if (brandToAdd.includes(ALL)) {
      setBrandToAdd([value]);  // Remove ALL BRANDS
      return;
    }

    // Otherwise just add normally (onChange will handle updating array)
  };

  const handleChange = (vals) => {
    // Prevent All Brands + others coexisting
    if (vals.includes(ALL) && vals.length > 1) {
      setBrandToAdd([ALL]);
      return;
    }

    setBrandToAdd(vals);
  };




  // Select / Deselect all branches
  const selectAllBranches = (brandId) => {
    const brand = accessContents.find((b) => b.BrandID === parseInt(brandId));
    const allBranches = brand?.Branches.map((b) => String(b.BranchID)) || [];
    setCurrentSelectedBrandData(
      currentSelectedBrandData.map((b) =>
        b.brandid === String(brandId) ? { ...b, branches: allBranches } : b
      )
    );
  };

  const deselectAllBranches = (brandId) => {
    setCurrentSelectedBrandData(
      currentSelectedBrandData.map((b) =>
        b.brandid === String(brandId) ? { ...b, branches: [] } : b
      )
    );
  };

  // Toggle permission (cycle: null → true → false → null)
  const togglePermission = (brandId, menuId, opId) => {
    setCurrentSelectedBrandData(
      currentSelectedBrandData.map((b) => {
        if (b.brandid !== String(brandId)) return b;

        const override = b.override_permissions || {};
        const menuOverride = override[menuId] || {};
        const current = menuOverride[opId] ?? null;

        let next;
        if (current === null) next = true;
        else if (current === true) next = false;
        else next = null;

        return {
          ...b,
          override_permissions: {
            ...override,
            [menuId]: { ...menuOverride, [opId]: next }
          }
        };
      })
    );
  };

  // Remove one brand
  const removeBrandAccess = (brandId) => {
    setCurrentSelectedBrandData(
      currentSelectedBrandData.filter((b) => b.brandid !== String(brandId))
    );
  };

  // Toggle branch for a specific brand
  const toggleBranch = (brandId, branchId) => {
    setCurrentSelectedBrandData(
      currentSelectedBrandData.map((b) => {
        if (b.brandid !== String(brandId)) return b;

        const hasBranch = b.branches.includes(String(branchId));
        return {
          ...b,
          branches: hasBranch
            ? b.branches.filter((id) => id !== String(branchId))
            : [...b.branches, String(branchId)]
        };
      })
    );
  };


  const handleContinue = () => {
    if (brandToAdd && brandToAdd.length > 0) {
      Modal.confirm({
        title: "Unsaved Selections",
        content: "You have selected brands but haven't added them yet. Do you want to discard these selections and proceed?",
        okText: "Yes, Discard & Proceed",
        cancelText: "No, Stay",
        onOk: () => {
          setBrandToAdd([]);
          onDataChange(currentSelectedBrandData);
          onStepComplete();
        },
        onCancel: () => {
          // Do nothing
        }
      });
      return;
    }

    onDataChange(currentSelectedBrandData);
    onStepComplete();
  };

  console.log("BrandsOverridesTab userData " + userData ? JSON.stringify(userData) : userData)
  const isAllBrands = currentSelectedBrandData.length === 0;

  return (
    <Card
      title={
        <span className="card-title">
          <Building size={16} /> Brand Access & Permission Overrides
        </span>
      }
    >
      <p className="subtitle">
        Set which brands this user can access. By default, they can access all brands. Each brand uses the user’s main role permissions, but you can limit them per brand if needed.
      </p>

      {/* Add brand selector */}
      <Space style={{ marginBottom: 16 }}>
        <Select
          mode="multiple"
          showSearch
          optionFilterProp="children"
          style={{ width: 280 }}
          placeholder="Select brands"
          value={brandToAdd}
          onSelect={handleSelect}
          onChange={handleChange}
          maxTagCount="responsive"
        >
          <Option key="__all_brands__" value="__all_brands__">
            All Brands
          </Option>

          {accessContents
            .filter(
              (b) =>
                !currentSelectedBrandData.some(
                  (d) => d.brandid === String(b.BrandID)
                )
            )
            .map((b) => (
              <Option key={b.BrandID} value={String(b.BrandID)}>
                {b.BrandName}
              </Option>
            ))}
        </Select>


        <Button
          type="primary"
          className="button-icon-text"
          icon={<Plus size={14} />}
          onClick={addBrandAccess}
          disabled={!brandToAdd || brandToAdd.length === 0}
        >
          Add Selected Brand(s)
        </Button>

      </Space>
      {isAllBrands && (
        <>
          <div className="all-brands-banner">
            ✅ This user has access to all current and future brands. When all brands are selected, permissions follow the main role and cannot be customized per brand.
          </div>
        </>
      )}
      {!isAllBrands && (
        <Collapse
          activeKey={activeBrands}
          onChange={setActiveBrands}
          expandIconPosition="end"
        >
          {currentSelectedBrandData.map((brandData) => {
            const brand = accessContents.find(
              (b) => b.BrandID === parseInt(brandData.brandid)
            );
            console.log("brand", JSON.stringify(brand));
            console.log("brandData", JSON.stringify(brandData));
            const branches = brand?.Branches || [];
            console.log("branches", branches);
            const hasOverride =
              brandData.override_permissions;

            console.log("hasOverride", hasOverride);
            return (
              <Panel
                key={brandData.brandid}
                header={
                  <div className="panel-header">
                    <div className="panel-header-left">
                      <Building size={16} className="brand-icon" />
                      <div>
                        <div className="brand-name">{brand?.BrandName}</div>
                      </div>
                      {hasOverride && <Tag color="blue">Override Active</Tag>}
                    </div>
                    <Button
                      type="text"
                      size="small"
                      danger
                      className="button-icon-text"
                      icon={<X size={14} />}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeBrandAccess(brandData.brandid);
                      }}
                    >
                      Remove Brand
                    </Button>
                  </div>
                }
              >
                {/* Branch Access Section */}
                <div className="branch-access">
                  <h4>Branch Access</h4>
                  <Space style={{ marginBottom: 8 }}>
                    <Button
                      size="small"
                      disabled={
                        (brandData && brandData.branches) ? branches.length === brandData.branches.length : false
                      }
                      onClick={() => selectAllBranches(brandData.brandid)}
                    >
                      Select All
                    </Button>
                    <Button
                      size="small"
                      disabled={branches.length === 0}
                      onClick={() => deselectAllBranches(brandData.brandid)}
                    >
                      Deselect All
                    </Button>
                  </Space>
                  {branches.map((branch) => (
                    <Checkbox
                      key={branch.BranchID}
                      checked={(brandData && brandData.branches) ? brandData.branches.includes(
                        String(branch.BranchID)
                      ) : true}
                      onChange={() =>
                        toggleBranch(brandData.brandid, branch.BranchID)
                      }
                    >
                      {branch.BranchName}
                    </Checkbox>
                  ))}
                </div>

                {/* Override Section */}
                {!hasOverride ? (
                  <div className="no-override">
                    <p className="inherit-text">
                      This brand inherits permissions from the main role (
                      {userData.mainRole}).
                    </p>
                    <Button
                      className="button-icon-text"
                      onClick={() =>
                        setCurrentSelectedBrandData(
                          currentSelectedBrandData.map((b) =>
                            b.brandid === brandData.brandid
                              ? { ...b, override_permissions: {} }
                              : b
                          )
                        )
                      }
                      icon={<Plus size={14} />}
                    >
                      Add Permission Override
                    </Button>
                  </div>
                ) : (
                  <div className="permissions-table-container">
                    <table className="permissions-table">
                      <thead>
                        <tr>
                          <th className="menu-col">Menu</th>
                          {crudOperations.map((op) => (
                            <th key={op.id} className="crud-col">
                              <div className="crud-header">
                                <span className="crud-name">{op.name}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {menuItems.map((menu) => (
                          <tr key={menu.id}>
                            <td className="menu-cell">{menu.name}</td>
                            {crudOperations.map((op) => {
                              const currentValue =
                                brandData.override_permissions?.[menu.id]?.[op.id] ??
                                null;
                              const checked = currentValue === true;
                              const indeterminate = currentValue === null;

                              return (
                                <td key={op.id} className="crud-cell">
                                  <Checkbox
                                    checked={checked}
                                    indeterminate={indeterminate}
                                    onChange={() =>
                                      togglePermission(
                                        brandData.brandid,
                                        menu.id,
                                        op.id
                                      )
                                    }
                                  />
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Panel>
            );
          })}
        </Collapse>

      )}
      {(!userData || Object.keys(userData).length === 0) && <Button type="primary" block onClick={handleContinue} style={{ marginTop: 16 }}>
        Next
      </Button>}
    </Card>
  );
});

export default BrandsOverridesTab;
